import { SimpleInvoice } from '@mews-commander/data-access';
import { LocalizedDateFromUtc } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedCurrencyValue, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DropdownItem } from '@optimus-web/core';

export const renderInvoiceItem = (invoice: SimpleInvoice) => {
    const primaryText = (
        <>
            <LocalizedText textKey={TextKey.Invoice} />
            {UnicodeEntity.NoBreakSpace}
            {invoice.invoiceNumber}
        </>
    );

    const secondaryText = (
        <>
            <LocalizedText textKey={TextKey.DueDate} />
            {UnicodeEntity.NoBreakSpace}
            {invoice.dueDateLocal ? <LocalizedDateFromUtc utcString={invoice.dueDateLocal} /> : null}
            {UnicodeEntity.NoBreakSpace}
            {UnicodeEntity.Pipe}
            {UnicodeEntity.NoBreakSpace}
            {invoice?.balance && <LocalizedCurrencyValue value={invoice.balance} />}
            {UnicodeEntity.NoBreakSpace}
            {UnicodeEntity.Pipe}
            {UnicodeEntity.NoBreakSpace}
            {invoice.ownerName}
        </>
    );

    return (
        <DropdownItem
            key={invoice.invoiceId}
            value={invoice.invoiceId}
            label={primaryText}
            description={secondaryText}
        />
    );
};
